import { All, Query } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import BankFindResults from "../components/BankFind/BankFindResults";

export function mapStateToProps({ appState, ui }: All) {
  return {
    appState: appState.bankFind as Query,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateActiveTab: (filterValue: number[]) => {
      dispatch(actions.updateFilter("activeStatus", filterValue));
    },
    updatePagination: () => {
      dispatch(actions.updatePagination("pageNumber", 1));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BankFindResults);
